import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from 'react-hook-form';
import { Creators as SettingsActions } from 'store/settings/settings-duck.js';
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material';
import { Container, FormWrapper } from './styled.js';
import PropTypes from 'prop-types';

const SettingsPage = ({ list, loading, settingsFetchAsync, settingsSaveAsync }) => {
  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    settingsFetchAsync();
  }, [settingsFetchAsync]);

  useEffect(() => {
    if (!list || list.length === 0) return;
    debugger; //eslint-disable-line
    const whatsappLink = list?.find((s) => s.key === 'whatsapp_link');
    const whatsappMessage = list?.find((s) => s.key === 'whatsapp_message');
    const whatsappProductMessage = list?.find((s) => s.key === 'whatsapp_product_message');
    if (whatsappLink && whatsappMessage && whatsappProductMessage) {
      reset({
        whatsappLink: whatsappLink.value,
        whatsappMessage: whatsappMessage.value,
        whatsappProductMessage: whatsappProductMessage.value,
      });
    }
  }, [list, reset]);

  const onSubmit = (data) => {
    debugger; //eslint-disable-line
    settingsSaveAsync({
      key: 'whatsapp_link',
      value: data.whatsappLink,
    });
    settingsSaveAsync({
      key: 'whatsapp_message',
      value: data.whatsappMessage,
    });
    settingsSaveAsync({
      key: 'whatsapp_product_message',
      value: data.whatsappProductMessage,
    });
  };

  return (
    <Container>
      <Typography variant="h5" gutterBottom>
        Configuração de WhatsApp
      </Typography>

      <FormWrapper component="form" onSubmit={handleSubmit(onSubmit)}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="whatsapp-link-label" shrink={true}>
            Número do Whatsapp
          </InputLabel>
          <TextField
            focused
            labelId="whatsapp-link-label"
            label="Link Do WhatsApp"
            {...register('whatsappLink', { required: 'O campo é obrigatório' })}
            disabled={loading}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel id="whatsapp-message-label" shrink={true}>
            Mensagem Padrão no WhatsApp
          </InputLabel>
          <TextField
            focused
            labelId="whatsapp-message-label"
            label="Mensagem Padrão no WhatsApp"
            {...register('whatsappMessage', { required: 'O campo é obrigatório' })}
            disabled={loading}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel id="whatsapp-product-message-label" shrink={true}>
            Mensagem para informações de produto no Whatsapp
          </InputLabel>
          <TextField
            focused
            labelId="whatsapp-product-message-label"
            label="Mensagem para informações de produto no Whatsapp"
            {...register('whatsappProductMessage', { required: 'O campo é obrigatório' })}
            disabled={loading}
          />
        </FormControl>

        <Box mt={2}>
          <Button type="submit" variant="contained" disabled={loading}>
            Salvar
          </Button>
        </Box>
      </FormWrapper>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  list: state.Settings.list,
  loading: state.Settings.loading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(SettingsActions, dispatch);
SettingsPage.propTypes = {
  list: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  settingsFetchAsync: PropTypes.func.isRequired,
  settingsSaveAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage);
